import { CardFormInput } from "./CardFormInput"

export function EditCardForm ({ formData, handleChange }) {

  return(
    <>
      <CardFormInput 
        dataProperty='name'
        formData={ formData }
        inputText='Spider Name'
        handleChange={ handleChange } 
        isRequired={true}
      />
      <CardFormInput 
        dataProperty='description'
        formData={ formData }
        inputText='Description'
        handleChange={ handleChange } 
        isRequired={true}
      />
      <CardFormInput 
        dataProperty='price'
        formData={ formData }
        inputText='Price'
        handleChange={ handleChange } 
        isRequired={true}
      />
      {/* <InputImage
        id='image'
        title='Image File'
        type='file'
        placeHolderText='Imaginous'
        handleImageUpload={handleImageUpload}
        file={file}
      /> */}
      <CardFormInput 
        dataProperty='available'
        formData={ formData }
        inputText='Available'
        handleChange={ handleChange } 
        isRequired={true}
      />
      <CardFormInput 
        dataProperty='dealVerbiage'
        formData={ formData }
        inputText='dealVerbiage'
        handleChange={ handleChange } 
        isRequired={true}
      />
      <CardFormInput 
        dataProperty='lot'
        formData={ formData }
        inputText='Lot Per Deal Price'
        handleChange={ handleChange } 
        isRequired={true}
      />
      <CardFormInput 
        dataProperty='pricePerLot'
        formData={ formData }
        inputText='Price Per Lot'
        handleChange={ handleChange } 
        isRequired={true}
      />
    </>
  )
}